import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { useAnalytics } from '../../../../common/analytics';
import { onCardRequestFailed } from '../../../../common/analytics/events';
var cards = new Map();
export var useTrelloCard = function useTrelloCard() {
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var loadCard = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cardId) {
      var response, cardResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("/1/card/".concat(cardId, "?fields=name,closed,url,cover,labels,idAttachmentCover&attachments=cover"));
          case 3:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 12;
              break;
            }
            _context.next = 7;
            return response.json();
          case 7:
            cardResponse = _context.sent;
            cards.set(cardId, cardResponse);
            return _context.abrupt("return", cardResponse);
          case 12:
            throw new Error("Invalid response: ".concat(response === null || response === void 0 ? void 0 : response.status));
          case 13:
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            if (_context.t0 instanceof Error) {
              fireAnalyticsEvent(_objectSpread({}, onCardRequestFailed({
                attributes: {
                  errorMsg: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message,
                  errorName: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.name
                }
              })));
            }
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 15]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [fireAnalyticsEvent]);
  var getCard = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cardId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", cards.get(cardId) ? Promise.resolve(cards.get(cardId)) : loadCard(cardId));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [loadCard]);
  return {
    getCard: getCard
  };
};